export default [
    {field: 'mobileNumber', required: true},
    {field: 'verificationCode', required: true}
];
